import { SvgIcon } from '@material-ui/core';


export const BoldCheckIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 24"
    style={{
      fontSize: 16,
      ...props.style,
    }}
  >
    <path
      d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
    />
  </SvgIcon>
);